module.exports = __webpack_public_path__ + "img/HZ-S4047.99ad5af1.jpg";